import React, { useCallback, useEffect, useState } from "react";
import "./SettingsTab.scss";
import Form from "react-bootstrap/Form";

import CardIcon11 from "assets/images/card1.png";
import CardIcon2 from "assets/icons/card2.svg";
import BiddinIcon1 from "assets/icons/bidding1.svg";
import BiddinIcon2 from "assets/icons/bidding2.svg";
// image imports
import SettingsTabIcon1 from "assets/images/SettingsTabIcon1.png";
import SettingsTabIcon2 from "assets/images/SettingsTabIcon2.png";
import SettingsTabIcon3 from "assets/images/SettingsTabIcon3.png";
import SettingsTabIcon4 from "assets/images/SettingsTabIcon4.png";
import MuteIcon from "assets/images/mute-icon.svg";
import SoundIcon from "assets/images/sound-icon.svg";
import { useTypedDispatch, useTypedSelector } from "store";
import { SettingState } from "types/user";
import { changeSettings } from "store/users/thunkActions";
import CrossIcon from "assets/icons/crossAccent.svg";
import { Modal } from "react-bootstrap";
import SettingsMobileTab from "./SettingsMobileTab";
import { showMobile } from "helpers/adaptation";

function SettingsTab() {
  const { settings } = useTypedSelector((store) => store.user);
  const dispatch = useTypedDispatch();
  const [sendSettings, setSendSettings] = useState<Partial<SettingState>>(settings);
  const [isShow, setIsShow] = useState(false);

  useEffect(() => {
    setSendSettings(settings);
  }, [settings]);

  const onChangeSetting = useCallback(
    (
      type:
        | "card_display"
        | "card_bidding"
        | "background_color"
        | "sound_site"
        | "double_click_card",
      value: { type: any }
    ) => {
      const localStor = localStorage.getItem("settings");
      let parseStorSettings: any = {};
      if (localStor) {
        parseStorSettings = JSON.parse(localStor);
      }

      switch (type) {
        case "card_display":
          setSendSettings({
            ...sendSettings,
            typeChooseCard: value.type
          });
          parseStorSettings.typeChooseCard = value.type;
          break;
        case "background_color":
          setSendSettings({
            ...sendSettings,
            fonColor: value.type
          });
          parseStorSettings.fonColor = value.type;
          break;
        case "sound_site":
          setSendSettings({
            ...sendSettings,
            sound: value.type
          });
          parseStorSettings.sound = value.type;
          break;
        case "card_bidding":
          setSendSettings({
            ...sendSettings,
            typeChooseCardBidding: value.type
          });
          parseStorSettings.typeChooseCardBidding = value.type;
          break;
        case "double_click_card":
          setSendSettings({
            ...sendSettings,
            playCardDblClick: value.type
          });
          parseStorSettings.playCardDblClick = value.type;
      }
    },
    [sendSettings]
  );
  console.log("sendSettings", sendSettings);
  const onSubmit = useCallback(async () => {
    try {
      await dispatch(changeSettings(sendSettings));
      setIsShow(true);
    } catch {
      //
    }
  }, [dispatch, sendSettings]);

  return (
    <>
      {showMobile && (
        <SettingsMobileTab
          settings={sendSettings}
          onChangeSetting={(
            type:
              | "card_display"
              | "card_bidding"
              | "background_color"
              | "sound_site"
              | "double_click_card",
            value: {
              type: any;
            }
          ) => onChangeSetting(type, value)}
          onSubmit={onSubmit}
        />
      )}
      {!showMobile && (
        <div className="SettingsTab-form-main">
          <div className="SettingsTab-form-otr">
            <div className="Settings-box-otr Settings-box-otr1">
              <div className="Settings-icon-otr">
                <img className="Settings-icon" src={SettingsTabIcon1} alt="icon" />
              </div>
              <h3 className="Settings-heading">צלילים</h3>
              <div className="sound-check-otr">
                <div
                  className="sound-check-inr sound-check-active"
                  onClick={() => onChangeSetting("sound_site", { type: true })}>
                  <Form.Check
                    type="radio"
                    aria-label="radio 1"
                    checked={sendSettings.sound}
                    name="sound_site"
                  />
                  <div className="sound-icon-text">
                    <div className="sound-icon-otr">
                      <img className="sound-icon volume-icon" src={SoundIcon} alt="icon" />
                      <img className="sound-icon mute-icon" src={MuteIcon} alt="icon" />
                    </div>
                    <p className="sound-text">הפעל צלילים</p>
                  </div>
                </div>
                <div
                  className="sound-check-inr"
                  onClick={() => onChangeSetting("sound_site", { type: false })}>
                  <Form.Check
                    type="radio"
                    aria-label="radio 1"
                    name="sound_site"
                    checked={!sendSettings.sound}
                  />
                  <div className="sound-icon-text">
                    <div className="sound-icon-otr">
                      <img className="sound-icon volume-icon" src={SoundIcon} alt="icon" />
                      <img className="sound-icon mute-icon" src={MuteIcon} alt="icon" />
                    </div>
                    <p className="sound-text">השתק צלילים</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="Settings-box-otr Settings-box-otr2">
              <div className="Settings-icon-otr">
                <img className="Settings-icon" src={SettingsTabIcon2} alt="icon" />
              </div>
              <h3 className="Settings-heading">צבע רקע</h3>
              <div className="select-background-otr">
                <div
                  className="select-background-inr"
                  onClick={() => onChangeSetting("background_color", { type: "blue" })}>
                  <Form.Check
                    type="radio"
                    aria-label="radio 1"
                    name="bacground_color"
                    checked={sendSettings.fonColor === "blue"}
                  />
                  <div className="select-background-color select-background-color1"></div>
                </div>
                <div
                  className="select-background-inr"
                  onClick={() => onChangeSetting("background_color", { type: "green" })}>
                  <Form.Check
                    type="radio"
                    aria-label="radio 1"
                    name="bacground_color"
                    checked={sendSettings.fonColor === "green"}
                  />
                  <div className="select-background-color select-background-color2"></div>
                </div>
                <div
                  className="select-background-inr"
                  onClick={() => onChangeSetting("background_color", { type: "white_blue" })}>
                  <Form.Check
                    type="radio"
                    aria-label="radio 1"
                    name="bacground_color"
                    checked={sendSettings.fonColor === "white_blue"}
                  />
                  <div className="select-background-color select-background-color3"></div>
                </div>
              </div>
            </div>
            <div className="Settings-box-otr Settings-box-otr3">
              <div className="Settings-icon-otr">
                <img className="Settings-icon" src={SettingsTabIcon3} alt="icon" />
              </div>
              <h3 className="Settings-heading">קלפים</h3>
              <div className="card-display-otr">
                <div
                  className="card-display-inr"
                  onClick={() => onChangeSetting("card_display", { type: "card" })}>
                  <Form.Check
                    type="radio"
                    aria-label="radio 1"
                    id="radio-card-display-2"
                    name="card-display"
                    checked={sendSettings.typeChooseCard === "card"}
                  />
                  <div className="card-display-box-otr" style={{ height: 125 }}>
                    <img src={CardIcon11} style={{ width: "83%", position: "absolute" }} />
                  </div>
                </div>
                <div
                  className="card-display-inr"
                  onClick={() => onChangeSetting("card_display", { type: "block" })}>
                  <Form.Check
                    type="radio"
                    aria-label="radio 1"
                    id="radio-card-display-2"
                    name="card-display"
                    checked={sendSettings.typeChooseCard === "block"}
                  />
                  <div className="card-display-box-otr" style={{ height: 125 }}>
                    <img src={CardIcon2} style={{ width: "83%", position: "absolute" }} />
                  </div>
                </div>
              </div>
            </div>
            <div className="Settings-box-otr Settings-box-otr4">
              <div className="Settings-icon-otr">
                <img className="Setings-icon" src={SettingsTabIcon4} alt="icon" />
              </div>
              <h3 className="Settings-heading">קופסת הכרזה</h3>
              <div className="card-display-otr">
                <div
                  className="card-display-inr"
                  onClick={() => onChangeSetting("card_bidding", { type: "block" })}>
                  <Form.Check
                    type="radio"
                    aria-label="radio 1"
                    id="radio-card-display-3"
                    name="card-display-bidding"
                    checked={sendSettings.typeChooseCardBidding === "block"}
                  />
                  <div
                    className="card-display-box-otr"
                    style={{ paddingBottom: 28, paddingTop: 28, height: 125 }}>
                    <img
                      src={BiddinIcon1}
                      style={{ width: "84%", height: 85, position: "absolute" }}
                    />
                  </div>
                </div>
                <div
                  className="card-display-inr"
                  onClick={() => onChangeSetting("card_bidding", { type: "card" })}>
                  <Form.Check
                    type="radio"
                    aria-label="radio 1"
                    id="radio-card-display-3"
                    name="card-display-bidding"
                    checked={sendSettings.typeChooseCardBidding === "card"}
                  />
                  <div
                    className="card-display-box-otr"
                    style={{ paddingBottom: 11, paddingTop: 11, height: 125 }}>
                    <img src={BiddinIcon2} style={{ width: "89%", position: "absolute" }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "center", marginTop: 35 }}>
            <input
              className="save-changes-btn"
              type="submit"
              style={{ width: 214, height: 68 }}
              name="submit"
              onClick={onSubmit}
              value="שמירת שינויים"
            />
          </div>
        </div>
      )}
      <Modal
        show={isShow}
        onHide={() => setIsShow(false)}
        centered
        animation={false}
        onExit={() => setIsShow(false)}
        onBackdropClick={() => setIsShow(false)}
        className="container-contact-modal">
        <div className="alert-global-wrapper">
          <div className="container-global-wrapper">
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                cursor: "pointer"
              }}
              onClick={() => setIsShow(false)}>
              <img src={CrossIcon} className="settings-img-modal" />
            </div>
            <div className="settings-title-modal-wrapper">
              <div className="settings-title-modal-container">
                <span className="settings-title-modal">ההעדפות נשמרו בהצלחה</span>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default SettingsTab;
